/**
 * Content Messages
 *
 * This contains all the text for the Content component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.knowledge.content';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Competency',
  },
});
